import { useRouter } from 'next/router';

import CommonLayout from '~/src/common/components/Layout/CommonLayout';
import Navigation from '~/src/common/components/Navigation/Navigation/Navigation';
import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import styles from '~/src/common/theme/classes/_classes.module.scss';
import {
  getGetRecipeByIdOrSlugQueryKey,
  getRecipeByIdOrSlug,
} from '~/src/queries/api-ecom/generated/api-ecom';
import RecipeScreen from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen';
import { CatalogContentLinkQueryParams } from '~/src/screens/CatalogContent/ContentScreen/types';

const Product = () => {
  const {
    query: { slug },
  } = useRouter<CatalogContentLinkQueryParams>();

  return (
    <CommonLayout>
      <Navigation source="Homepage" />
      <div className={styles.productsLayoutContainer}>
        {/* L'utilisation de `key` permet de forcer le rechargement de l'écran au changement de slug */}
        <RecipeScreen key={slug} />
      </div>
    </CommonLayout>
  );
};

export const getServerSideProps = withEnhancedGSSP(async ({ query }, { prefetch, redirect }) => {
  const slug = String(query.slug);
  const pRecipe = prefetch(getGetRecipeByIdOrSlugQueryKey(slug), () => getRecipeByIdOrSlug(slug));
  // Chargement des catégories principales
  const pRedirect = pRecipe.then(recipe => {
    if (recipe.slugs[0] !== slug) redirect(`/recette/${recipe.slugs[0]}`);
  });
  // Attente de la fin des requêtes
  await Promise.all([pRecipe, pRedirect]);
});

export default Product;
